/**
 * Resolves the logged-in user's approval level for the Spot enquiry approval flow.
 * A user listed in companySettingData.enquiry.enquiry_approvers is an approver at
 * that level (defaulting to 1 when no level is set). Anyone else is treated as L0
 * (the enquiry creator / requester).
 */
export const getCurrentUserApprovalLevel = (companySettingData, userDetails) => {
  const currentApprover = companySettingData?.enquiry?.enquiry_approvers?.find(
    (approver) => approver.email === userDetails?.email
  );
  return currentApprover ? (currentApprover.level || 1) : 0;
};
